<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <div v-if="enableMaterialFields">
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Transport Details
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="typet"
                :label="this.localForm.typet"
                :items="orderTransportOptions"
                color="wplblue0"
                prepend-icon="local_shipping"
                hint="transport type"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.add"
              :rules="ruleMustBeFilledANDLessThan50"
              prepend-icon="home"
              hint="delivery address"
              persistent-hint
              required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.cons"
              :rules="ruleMustBeFilledANDLessThan50"
              prepend-icon="pin"
              hint="consingment number"
              persistent-hint
              required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <DatePicker :date= "{
                obj: 'stats.deta',
                label: dateTypeA(this.getDetailStats.deta),
                hint: 'eta date',
                icon: 'login'
                }"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs12 md8 lg6>
                <v-text-field
                :change="updateFormChar()"
                v-model="localForm.goods"
                :rules="ruleMustBeFilledANDLessThan50"
                color="wplblue0"
                prepend-icon="inventory_2"
                hint="goods"
                persistent-hint
                required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md8 lg6>
                <v-text-field
                :change="updateFormChar()"
                v-model="localForm.haz"
                :rules="ruleMustBeFilledANDLessThan50"
                prepend-icon="warning"
                hint="hazards"
                persistent-hint
                required
                ></v-text-field>
              </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">

          </v-layout>
          <v-layout row wrap class="ml-2 mr-2" v-if="enableHireFields">
            <v-flex xs12 md8 lg6>
              <DatePicker :date= "{
                obj: 'stats.dmob',
                label: dateTypeA(this.getDetailStats.dmob),
                hint: 'mob. date',
                icon: 'login'
                }"
              />
            </v-flex>
            <v-flex xs12 md8 lg6>
              <DatePicker :date= "{
                obj: 'stats.demob',
                label: dateTypeA(this.getDetailStats.demob),
                hint: 'demob. date',
                icon: 'logout'
                }"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.batch"
              :rules="ruleMustBeFilledANDLessThan50"
              prepend-icon="widgets"
              hint="batch id"
              persistent-hint
              required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="qa"
                :label="this.localForm.qa"
                :items="orderQualityAssurancetOptions"
                color="wplblue0"
                prepend-icon="add_moderator"
                hint="quality"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="enableServiceFields">
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Service Mobilisation
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="localForm.mob"
                :items="orderMobilisationOptions"
                color="wplblue0"
                prepend-icon="flight"
                hint="orgin"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="localForm.statt"
                :items="orderMobilisationStatusOptions"
                color="wplblue0"
                prepend-icon="adjust"
                hint="status"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2" v-if="enableHireFields">
            <v-flex xs12 md8 lg6>
              <DatePicker :date= "{
                obj: 'stats.dmob',
                label: dateTypeA(this.getDetailStats.dmob),
                hint: 'mob. date',
                icon: 'login'
                }"
              />
            </v-flex>
            <v-flex xs12 md8 lg6>
              <DatePicker :date= "{
                obj: 'stats.demob',
                label: dateTypeA(this.getDetailStats.demob),
                hint: 'demob. date',
                icon: 'logout'
                }"
              />
            </v-flex>
          </v-layout>
        </div>
        <div v-if="enableMaterialFields">
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Transport Vendor
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
                <v-text-field
                :change="updateFormChar()"
                v-model="localForm.vtt"
                :rules="ruleMustBeFilledANDLessThan50"
                prepend-icon="directions_boat"
                hint="transport vendor"
                persistent-hint
                required
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md8 lg6>
                <v-text-field
                :change="updateFormChar()"
                v-model="localForm.vidt"
                :rules="ruleMustBeFilledANDLessThan50"
                prepend-icon="fingerprint"
                hint="vendor id"
                persistent-hint
                required
                ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
                <v-text-field
                v-model="localForm.costt"
                :change="updateFormChar()"
                :rules="mustBeZeroOrMore"
                :suffix="this.getDetailChar.costu"
                prepend-icon="paid"
                hint="transport cost"
                persistent-hint
                required
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md8 lg6>
                <v-text-field
                v-model="localForm.carbt"
                :change="updateFormChar()"
                :rules="mustBeZeroOrMore"
                :suffix="this.getDetailChar.carbu"
                prepend-icon="co2"
                hint="transport carbon"
                persistent-hint
                required
                ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="true">
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Transport and Quality Requirements
            </div>
          </v-layout>
          <v-layout row wrap class="ml-3 mr-2 mt-4">
            <v-flex xs12>
              <v-textarea
                :change="updateFormChar()"
                :color="ui.textColor"
                :background-color="ui.btnColor"
                v-model="localForm.trans"
                :disabled="false"
                :outline="true"
                :rules="ruleMustBeNotUndefinedANDLessThan2000"
                hint="transport and quality comments"
                auto-grow
                persistent-hint
                ></v-textarea>
              </v-flex>
            </v-layout>
        </div>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import orderOptions from "@/data/options/mixins/orderOptions.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import DatePicker from "@/data/functions/components/DatePicker";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";

import { mapGetters } from "vuex";
export default {
  components: {
    DatePicker
  },
  data() {
    return {
      valid: true,
      localForm: {
        qa: "",
        mob: "",
        typet: "",
        statt: "",
        cons: "",
        trans: "",
        vidt: "",
        vtt: "",
        costt: "",
        carbt: "",
        goods: "",
        haz: "",
        add: ""
      },
      orgForm: {
        qa: "",
        mob: "",
        typet: "",
        statt: "",
        cons: "",
        trans: "",
        vidt: "",
        vtt: "",
        costt: "",
        carbt: "",
        goods: "",
        haz: "",
        add: ""
      },
      typet: "",
      statt: "",
      qa: "",
      mob: ""
    };
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.add = this.getDetail.char.add;
    this.localForm.typet = this.getDetail.char.typet;
    this.localForm.statt = this.getDetail.char.statt;
    this.localForm.qa = this.getDetail.char.qa;
    this.localForm.mob = this.getDetail.char.mob;
    this.localForm.trans = this.getDetail.char.trans;
    this.localForm.cons = this.getDetail.char.cons;
    this.localForm.batch = this.getDetail.char.batch;
    this.localForm.vtt = this.getDetail.char.vtt;
    this.localForm.vidt = this.getDetail.char.vidt;
    this.localForm.costt = this.getDetail.char.costt;
    this.localForm.carbt = this.getDetail.char.carbt;
    this.localForm.goods = this.getDetail.char.goods;
    this.localForm.haz = this.getDetail.char.haz;

    this.orgForm.add = this.getDetail.char.add;
    this.orgForm.typet = this.getDetail.char.typet;
    this.orgForm.statt = this.getDetail.char.statt;
    this.orgForm.qa = this.getDetail.char.qa;
    this.orgForm.mob = this.getDetail.char.mob;
    this.orgForm.trans = this.getDetail.char.trans;
    this.orgForm.cons = this.getDetail.char.cons;
    this.orgForm.batch = this.getDetail.char.batch;
    this.orgForm.vtt = this.getDetail.char.vtt;
    this.orgForm.vidt = this.getDetail.char.vidt;
    this.orgForm.costt = this.getDetail.char.costt;
    this.orgForm.carbt = this.getDetail.char.carbt;
    this.orgForm.goods = this.getDetail.char.goods;
    this.orgForm.haz = this.getDetail.char.haz;
  },
  watch: {
    qa() {
      this.localForm.qa = this.qa;
      this.updateFormChar();
    },
    mob() {
      this.localForm.mob = this.mob;
      this.updateFormChar();
    },
    typet() {
      this.localForm.typet = this.typet;
      this.updateFormChar();
    },
    statt() {
      this.localForm.statt = this.statt;
      this.updateFormChar();
    }
  },
  // eslint-disable-next-line
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    orderOptions,
    techOptions,
    dateFunctions
  ],
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailChar",
      "getDetailStats",
      "getCurrentPage"
    ]),
    enableMaterialFields() {
      let logic = null;
      if (
        this.getDetailChar.type === "ML1" ||
        this.getDetailChar.type === "MW1" ||
        this.getDetailChar.type === "MW2"
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableServiceFields() {
      let logic = null;
      if (
        this.getDetailChar.type === "SE2" ||
        this.getDetailChar.type === "SW1" ||
        this.getDetailChar.type === "SW2"
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableHireFields() {
      let logic = null;
      if (
        this.getDetailChar.type === "HW1" ||
        this.getDetailChar.type === "HW2"
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;

      // eslint-disable-next-line
      if (
        this.localForm.goods !== this.orgForm.goods &&
        this.localForm.goods !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.goods = this.localForm.goods;
        // basic
        char.goods = this.localForm.goods;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.haz !== this.orgForm.haz &&
        this.localForm.haz !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.haz = this.localForm.haz;
        // basic
        char.haz = this.localForm.haz;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      // eslint-disable-next-line
      if (
        this.localForm.carbt !== this.orgForm.carbt &&
        this.localForm.carbt !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.carbt = this.localForm.carbt;
        // basic
        char.carbt = this.localForm.carbt;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      // eslint-disable-next-line
      if (
        this.localForm.costt !== this.orgForm.costt &&
        this.localForm.costt !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.costt = this.localForm.costt;
        // basic
        char.costt = this.localForm.costt;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      // eslint-disable-next-line
      if (
        this.localForm.vtt !== this.orgForm.vtt &&
        this.localForm.vtt !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.vtt = this.localForm.vtt;
        // basic
        char.vtt = this.localForm.vtt;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.vidt !== this.orgForm.vidt &&
        this.localForm.vidt !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.vidt = this.localForm.vidt;
        // basic
        char.vidt = this.localForm.vidt;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      // eslint-disable-next-line
      if (
        this.localForm.batch !== this.orgForm.batch &&
        this.localForm.batch !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.batch = this.localForm.batch;
        // basic
        char.batch = this.localForm.batch;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      // eslint-disable-next-line
      if (
        this.localForm.cons !== this.orgForm.cons &&
        this.localForm.cons !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.cons = this.localForm.cons;
        // basic
        char.cons = this.localForm.cons;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      // eslint-disable-next-line
      if (
        this.localForm.typet !== this.orgForm.typet &&
        this.localForm.typet !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.typet = this.localForm.typet;
        // basic
        char.typet = this.localForm.typet;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (this.localForm.qa !== this.orgForm.qa && this.localForm.qa !== "") {
        // after the change re-assign new Local to org
        this.orgForm.qa = this.localForm.qa;
        // basic
        char.qa = this.localForm.qa;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.mob !== this.orgForm.mob &&
        this.localForm.mob !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.mob = this.localForm.mob;
        // basic
        char.mob = this.localForm.mob;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.add !== this.orgForm.add &&
        this.localForm.add !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.add = this.localForm.add;
        // basic
        char.add = this.localForm.add;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 6); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.statt !== this.orgForm.statt &&
        this.localForm.statt !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.statt = this.localForm.statt;
        // basic
        char.statt = this.localForm.statt;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 6); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.trans !== this.orgForm.trans &&
        this.localForm.trans !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.trans = this.localForm.trans;
        // basic
        char.trans = this.localForm.trans;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 9); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
